import React from "react";
import { useSelector } from "react-redux";
import useDispatchTrailer from "../hooks/useDispatchTrailer";

const VideoBackground = ({ movieId }) => {
	const trailer = useSelector((store) => store.movies?.trailer);
	useDispatchTrailer(movieId);

	return (
		<div className="w-full box-border absolute">
			<iframe
				className="w-full aspect-video box-border"
				src={
					"https://www.youtube.com/embed/" + trailer?.key + "?autoplay=1&mute=1"
				}
				title="YouTube video player"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
			></iframe>
		</div>
	);
};

export default VideoBackground;
